import apiClient from './client';

export const shopifyAPI = {
  // OAuth (nuovo - 2026)
  oauthAuthorize: async (shop = null) => {
    const params = shop ? { shop } : {};
    const response = await apiClient.get('/integrations/shopify/oauth/authorize/', { params });
    return response.data;
  },

  oauthCallback: async (params) => {
    const response = await apiClient.get('/integrations/shopify/oauth/callback/', { params });
    return response.data;
  },

  oauthStatus: async (shop = null) => {
    const params = shop ? { shop } : {};
    const response = await apiClient.get('/integrations/shopify/oauth/status/', { params });
    return response.data;
  },

  oauthDisconnect: async (reason = 'User requested disconnect') => {
    const response = await apiClient.post('/integrations/shopify/oauth/disconnect/', { reason });
    return response.data;
  },

  // Auth (legacy - mantieni per compatibilità)
  validateToken: async () => {
    const response = await apiClient.get('/integrations/shopify/auth/validate/');
    return response.data;
  },

  getTokenInfo: async () => {
    const response = await apiClient.get('/integrations/shopify/auth/info/');
    return response.data;
  },

  // Sync Logs
  getSyncLogs: async (params = {}) => {
    const response = await apiClient.get('/integrations/shopify/sync-logs/', { params });
    return response.data;
  },

  // Webhook Logs
  getWebhookLogs: async (params = {}) => {
    const response = await apiClient.get('/integrations/shopify/webhook-logs/', { params });
    return response.data;
  },

  // Sync Status
  getSyncStatus: async () => {
    const response = await apiClient.get('/integrations/shopify/sync-status/');
    return response.data;
  },

  // Manual Sync Trigger
  triggerSync: async (type = 'inventory') => {
    const response = await apiClient.post('/integrations/shopify/trigger-sync/', { type });
    return response.data;
  },
};

export default shopifyAPI;
